<template>
  <div class="pt-2 secondary">
    <div class="text-h6 text-center mb-2">{{ groupName }} | {{ itemName }}</div>

    <v-text-field
      label="Title"
      color="primary"
      dense
      outlined
      hide-details
      dark
      class="mb-2"
    ></v-text-field>

    <v-textarea
      dense
      outlined
      hide-details
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Description"
    ></v-textarea>

    <v-text-field
      dense
      outlined
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Starts at"
      hint="Enter the starting point of video (Minute:Seconds)"
      persistent-hint
    ></v-text-field>

    <v-text-field
      dense
      outlined
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Ends at"
      hint="Enter the ending point of video (Minute:Seconds)"
      persistent-hint
    ></v-text-field>

    <v-file-input
      accept="video/mp4,video/x-m4v,video/*"
      label="Subtitles"
      outlined
      dense
      dark
      prepend-icon=""
      prepend-inner-icon="$file"
    >
    </v-file-input>

    <v-checkbox
      dark
      :ripple="false"
      color="primary"
      dense
      hide-details
      class="pa-0 ma-0 mb-4"
      label="Show Player Controls"
    ></v-checkbox>

    <v-file-input
      accept="video/mp4,video/x-m4v,video/*"
      v-model="video"
      ref="video"
      id="videoInput"
      v-show="false"
      @change="onVideoChange"
    >
    </v-file-input>

    <v-row class="mb-5">
      <v-col cols="2">
        <div class="file-wrapper rounded">
          <label
            class="
              d-flex
              flex-column
              align-center
              justify-center
              add-file
              primary
              pa-2
              rounded
            "
            for="videoInput"
          >
            <v-icon color="white" class="mb-2">mdi-plus</v-icon>
            <div class="body-2 white--text text-center">Add video</div>
          </label>
        </div>
      </v-col>

      <v-col cols="2">
        <div class="file-wrapper rounded" v-if="thumbnail && video">
          <div
            class="
              file-overlay
              d-flex
              flex-column
              align-center
              justify-center
              rounded
            "
          >
            <div class="caption font-weight-bold white--text text-center">
              {{ video.name }}
            </div>

            <v-btn icon small color="error" @click="deleteVideo()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>

          <img :src="thumbnail" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["groupName", "itemName"],
  data() {
    return {
      video: null,
      thumbnail: null,
    };
  },
  methods: {
    getVideoCover(file, seekTo = 0.0) {
      console.log("getting video cover for file: ", file);
      return new Promise((resolve, reject) => {
        // load the file to a video player
        const videoPlayer = document.createElement("video");
        videoPlayer.setAttribute("src", URL.createObjectURL(file));
        videoPlayer.load();
        videoPlayer.addEventListener("error", (ex) => {
          reject("error when loading video file", ex);
        });
        // load metadata of the video to get video duration and dimensions
        videoPlayer.addEventListener("loadedmetadata", () => {
          // seek to user defined timestamp (in seconds) if possible
          if (videoPlayer.duration < seekTo) {
            reject("video is too short.");
            return;
          }
          // delay seeking or else 'seeked' event won't fire on Safari
          setTimeout(() => {
            videoPlayer.currentTime = seekTo;
          }, 200);
          // extract video thumbnail once seeking is complete
          videoPlayer.addEventListener("seeked", () => {
            console.log("video is now paused at %ss.", seekTo);
            // define a canvas to have the same dimension as the video
            const canvas = document.createElement("canvas");
            canvas.width = videoPlayer.videoWidth;
            canvas.height = videoPlayer.videoHeight;
            // draw the video frame to canvas
            const ctx = canvas.getContext("2d");
            ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
            // return the canvas image as a blob
            ctx.canvas.toBlob(
              (blob) => {
                resolve(blob);
              },
              "image/jpeg",
              0.75 /* quality */
            );
          });
        });
      });
    },
    async onVideoChange(video) {
      if (video) {
        const cover = await this.getVideoCover(this.video, 5);
        this.thumbnail = URL.createObjectURL(cover);
      }
    },
    deleteVideo() {
      this.video = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-wrapper {
  padding-bottom: 100%;
  position: relative;

  .file-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(#000, 0.4);
    z-index: 1;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .add-file {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
}
</style>